import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import {
    androidScreenMarginBottom,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    loading: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: COLOR.BLACK_OVERLAY(0.5),
        zIndex: 999,
    },
    cancelButtonText: {
        color: COLOR.background,
    },
    button: {
        minWidth: isTabletOrWeb ? 120 : widthPercentageToDP(120),
    },
    actionButton: {
        marginLeft: 12,
    },
    dialogBackground: {
        zIndex: 999,
        ...StyleSheet.absoluteFillObject,
        backgroundColor: COLOR.BLACK,
        marginBottom: androidScreenMarginBottom,
    },
    pinBackground: {
        backgroundColor: COLOR.BLACK,
    },
});

export default styles;
